<div.panel>
    <div.panelTop>
        <div>
            <div.input>输入</div>
        </div>
        <div>
            <button.btn-beautify type="button" onClick("handleBeautifyJsonClick")>Beautify</button>
            <button.btn-minify type="button" onClick("handleMinifyJsonClick")>Minify</button>
            <div.output>输出</div>
        </div>
    </div>
    <div.panelMiddle>
        <div.panelLeft><textarea.testareaLeft key="ar1" value=state.ar1/></div>
        <div.panelRight><textarea.testareaRight key="ar2" value=state.ar2/></div>
    </div>
    <!-- <table style="width:100%;height:100%">
        <tr>
            <td style="width:1%"/>
            <td style="width:44%">
                
            </td>
            <td style="width:10%">
                
            </td>
            <td style="width:44%">
               
            </td>
            <td style="width:1%"/>
        </tr>
    </table> -->
</div>
